import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntTextareaComponent} from "./int-textarea.components";
import {IntLabeledFieldBoxModule} from "../boxes";
import {IntDefaultInputModule} from "../fields";

@NgModule({
  imports: [CommonModule, IntLabeledFieldBoxModule, IntDefaultInputModule],
  declarations: [IntTextareaComponent],
  exports: [IntTextareaComponent]
})
export class IntTextareaModule {

}
